// noinspection JSUnresolvedVariable

const policyDataFields = new Map<string, string>();
policyDataFields.set('name', 'Name');
policyDataFields.set('firstName', 'Vorname');
policyDataFields.set('lastName', 'Nachname');
policyDataFields.set('title', 'Titel / Grad');
policyDataFields.set('username', 'Benutzername');
policyDataFields.set('contacts', 'Kontaktmöglichkeiten');
policyDataFields.set('picture', 'Bild');
policyDataFields.set('company', 'RFA / Gemeinschaftseinrichtung / Firma');
policyDataFields.set('adGroups', 'AD-Gruppen / AD-Rollen');
policyDataFields.set('uidNumber', 'UID Nummer');
policyDataFields.set('room', 'Raum / Standort');
policyDataFields.set('department', 'Abteilung / Bereich');
policyDataFields.set('departmentReplacement', 'Alternative Abteilung / Bereich');
policyDataFields.set('jobDescription', 'Job Beschreibung');
policyDataFields.set('absences', 'Abwesenheiten');
policyDataFields.set('officeHours', 'Dienstzeiten');
policyDataFields.set('businessTrips', 'Dienstreisen');
policyDataFields.set('workplace', 'Arbeitsort');
policyDataFields.set('overtime', 'Überstunden');
policyDataFields.set('teamMemberships', 'Teamzugehörigkeiten');
policyDataFields.set('comments', 'Kommentare in Freitext-Felder');
policyDataFields.set('costCentre', 'Kostenstellen');
policyDataFields.set('chief', 'Vorgesetzte');
policyDataFields.set('costCentreResponsible', 'Kostenstellenverantwortliche');
policyDataFields.set('hostname', 'Computername');
policyDataFields.set('telephone', 'Telefonnummer');
policyDataFields.set('mobile', 'Mobiltelefonnummer');
policyDataFields.set('fax', 'Faxnummer');

const systems = new Map<string, string>();
systems.set('activeDirectory', 'Active Directory');
systems.set('djinvoice', 'Djinvoice');
systems.set('sap', 'SAP');
systems.set('speedikon', 'Speedikon');
systems.set('phoneBook', 'Telefonbuch');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function generateDataFieldList(fieldsObject: any): string {
  let html = '<ul>' + Object.keys(fieldsObject).filter(field => field !== 'logs' && fieldsObject[field]).map(field => '<li>' + (policyDataFields.get(field) ?? field) + '</li>').join('');
  if (fieldsObject.logs?.length) {
    html += '<li>Log-Daten (' + fieldsObject.logs.join(', ') + ')</li>';
  }
  html += '</ul>';
  return html;
}

function generatePrivacyPolicy(element: Element): void {
  element.classList.add('generated');
  element.innerHTML = '';

  const src = element.getAttribute('data-src');
  if (!src) {
    return;
  }

  element.ariaBusy = 'true';

  fetch(src).then(response => response.json())
    .then((policy) => {
      let html = '';

      // title
      if (policy.name) {
        html += '<h3 class="mb-4">Datenschutzerklärung der Applikation ' + policy.name + '</h3>';
      }

      html += '<p>gemäß Art. 13 EU-Datenschutz-Grundverordnung (DSGVO)</p>';

      // responsible person
      html += '<p class="fw-bold">Verantwortlicher für die Datenverarbeitung</p>\n<p>Verantwortlicher im Sinne der EU-Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze sowie sonstiger datenschutzrechtlicher Bestimmungen ist der:</p>\n<p class="ps-3">Rundfunk Berlin-Brandenburg (rbb)<br>vertreten durch die Intendantin<br>Anstalt des öffentlichen Rechts<br>Masurenallee 8-14<br>14057 Berlin</p>';

      // data protection officer
      html += '<p class="fw-bold">Kontakt und Auskunft in Datenschutzfragen</p>\n<p>Kontaktdaten der Datenschutzbeauftragten des rbb</p>\n<p class="ps-3">Nicoleta-Simina Constantin<br>Masurenallee 8-14<br>14057 Berlin<br>E-Mail: <a href="mailto:datenschutz@rbb-online.de">datenschutz@rbb-online.de</a></p>';

      // rights of the affected person
      if (policy.rightsOfTheAffectedPerson?.responsibleForTheApplication && policy.rightsOfTheAffectedPerson.email) {
        html += '<p>Kontaktdaten ' + policy.rightsOfTheAffectedPerson.responsibleForTheApplication + '</p><p class="ps-3">' + policy.rightsOfTheAffectedPerson.responsibleForTheApplication + '<br>E-Mail: <a href="mailto:' + policy.rightsOfTheAffectedPerson.email + '">' + policy.rightsOfTheAffectedPerson.email + '</a>';
        if (policy.rightsOfTheAffectedPerson.telephone) {
          html += '<br>Telefon: ' + policy.rightsOfTheAffectedPerson.telephone;
        }
        html += '</p>';
      }

      // purpose
      if (policy.purpose?.description) {
        html += '<p class="fw-bold">Zweck der Datenverarbeitung</p>\n<p>' + policy.purpose.description + '</p>';
      }

      // processed data
      if (policy.processedData?.dataDescriptions) {
        html += '<p class="fw-bold">Verarbeitete Daten</p>\n<p>Innerhalb der Applikation ' + policy.name + ' werden personenbezogene Daten unter Beachtung der DSGVO und anderer nationaler Datenschutzgesetze sowie sonstiger datenschutzrechtlicher Bestimmungen verarbeitet.</p>\n<p>Es werden folgende personenbezogene Daten verarbeitet:</p>';
        html += generateDataFieldList(policy.processedData.dataDescriptions);
      }

      html += '<p class="fw-bold">Rechtsgrundlage</p>\n<p>Innerhalb der Applikation ' + policy.name + ' werden personenbezogene Daten auf der Grundlage von Art. 6 Abs. 1 b) DSGVO (Daten der freien Mitarbeiterinnen und Mitarbeiter) bzw. § 46 rbb-Staatsvertrag i. V. m. § 18 Berliner Datenschutzgesetz i. V. m. § 26 Abs. 8 Bundesdatenschutzgesetz (Daten der Arbeitnehmerinnen und Arbeitnehmer) verarbeitet.</p>';

      // data collection
      if (policy.dataCollection?.systems) {
        html += '<p class="fw-bold">Datenquellen</p>\n<p>Ihre personenbezogenen Daten werden teilweise aus anderen Systemen innerhalb des rbb-Datennetzes über Schnittstellen abgerufen. Im Folgenden sind die Systeme mit den entsprechenden personenbezogenen Daten aufgelistet:</p>';
        Object.keys(policy.dataCollection.systems).forEach((system) => {
          if (policy.dataCollection.systems[system]) {
            html += '<p class="text-underline">' + (systems.get(system) ?? system) + '</p>\n' + generateDataFieldList(policy.dataCollection.systems[system]);
          }
        });
      }

      // data transmission
      html += '<p class="fw-bold">Datenweitergabe</p>\n<p>';
      if (policy.dataTransmission.dmz) {
        html += 'Die Daten werden auf rbb-eigene Systeme verarbeitet. Die Anwendung ist über das Internet erreichbar und kann nur von berechtigten rbb-Mitarbeiterinnen und rbb-Mitarbeitern aufgerufen werden.';
      } else if (policy.dataTransmission.ard) {
        html += 'Die personenbezogenen Daten werden innerhalb des ARD-Datennetzes verarbeitet.';
      } else {
        html += 'Die personenbezogenen Daten werden innerhalb des rbb-Datennetzes verarbeitet.';
      }
      html += '</p>\n';
      if (policy.dataTransmission && (policy.dataTransmission.internal || policy.dataTransmission.external)) {
        if (policy.dataTransmission.internal) {
          html += '<p>' + policy.dataTransmission.internal + '</p>';
        }
        if (policy.dataTransmission.external) {
          html += '<p>' + policy.dataTransmission.external + '</p>';
        }
      } else {
        html += '<p>Die gespeicherten Daten werden weder an externe Dienstleister noch an interne Stellen im rbb weitergeleitet.</p>';
      }

      // data storage duration
      html += '<p class="fw-bold">Datenspeicherdauer</p>\n<p>Wir löschen Ihre personenbezogenen Daten, sobald sie für die oben genannten Zwecke nicht mehr erforderlich sind bzw. sofern gesetzliche Aufbewahrungsfristen eine Löschung erlauben.</p>';
      if (policy.dataStorageDuration?.description) {
        html += '<p>' + policy.dataStorageDuration.description + '</p>';
      }

      // rights of the affected person
      if (policy.name && policy.rightsOfTheAffectedPerson?.responsibleForTheApplication) {
        html += '<!--suppress GrazieInspection --><p class="fw-bold">Rechte der Betroffenen</p>\n<p>Gemäß DSGVO haben Sie folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten (Betroffenenrechte gem. Art. 15 ff. DSGVO):</p>\n<ul>\n    <li>Recht auf Auskunft</li>\n    <li>Recht auf Berichtigung</li>\n    <li>Recht auf Löschung</li>\n    <li>Recht auf Einschränkung der Verarbeitung</li>\n    <li>Recht zum Widerruf</li>\n</ul>';
        if (policy.rightsOfTheAffectedPerson.email) {
          html += '<p>Entsprechende Begehren richten Sie bitte an die:</p><p class="ps-3">' + policy.rightsOfTheAffectedPerson.responsibleForTheApplication + '<br>E-Mail: <a target="_blank" href="mailto:' + policy.rightsOfTheAffectedPerson.email + '">' + policy.rightsOfTheAffectedPerson.email + '</a>';
          if (policy.rightsOfTheAffectedPerson.telephone) {
            html += '<br>Telefon: ' + policy.rightsOfTheAffectedPerson.telephone;
          }
          html += '</p>';
        }
        html += '<p>Sie haben gemäß Art. 77 DSGVO das Recht, sich bei der Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten nicht rechtmäßig erfolgt. Aufsichtsbehörde ist</p>\n<p class="ps-3">der Rundfunkdatenschutzbeauftragte für den Datenschutz beim BR, HR, MDR, rbb, SR, SWR, WDR, Deutschlandradio und ZDF<br>Stephan Schwarze<br>Kantstraße 71-73<br>04275 Leipzig<br>E-Mail: <a target="_blank" href="mailto:kontakt@rundfunkdatenschutz.de">kontakt@rundfunkdatenschutz.de</a></p>';
      }

      // further advices
      html += '<p class="fw-bold">Weitere Hinweise</p>\n<p>Für feste und freie Mitarbeiter des rbb finden die Regelungen aus der allgemeinen <a href="https://rbb.sharepoint.com/:b:/r/sites/Intranet-Datenschutz/Freigegebene Dokumente/Datenschutzerkl%C3%A4rungen/Datenschutzerkl%C3%A4rung - HA Personal.pdf">Datenschutzinformation der HA Personal</a> Anwendung.</p>';

      if (!window.location.href.includes('tools.rbb-online.de/home')) {
        html += '<p>Des Weiteren ist bei der Nutzung von Eigenentwicklungen des Bereichs Infrastruktur Software die <a href="https://tools.rbb-online.de/home/privacy" target="_blank">Datenschutzerklärung von rbb Tools</a> zu beachten.</p>';
      }

      element.innerHTML = html;
      element.ariaBusy = 'false';
    });
}

const insertPrivacyPolicy = (): void => document.querySelectorAll('div.privacy-policy:not(.generated)').forEach(item => generatePrivacyPolicy(item));

const observer = new MutationObserver(insertPrivacyPolicy);
observer.observe(document, { childList: true, subtree: true });
